import { useState } from "react";

import { useTimeout } from "usehooks-ts";

import { Pill } from "src/base-components/Pill";
import { EntityPill } from "src/copilot/EntityPill";
import { EntitySchemaResource } from "src/entities/queries";

type Props = {
  entity: EntitySchemaResource | null;
  delay: number;
};

export const EntityMention = ({ entity, delay }: Props) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && (
      <span className="mx-1 inline-flex">
        {entity ? (
          <EntityPill resource={entity} />
        ) : (
          <Pill size="sm" variant="gray" fullWidth>
            <Pill.Text>Entity not found</Pill.Text>
          </Pill>
        )}
      </span>
    )
  );
};
